
<script>
import vue2Dropzone from "vue2-dropzone";
import { vendorService } from "../../services";
import { required } from "vuelidate/lib/validators";
import config from "../../config";
import { error_message, success_message } from "../../Helper/helper";
import DropzonePopup from "../../components/widgets/dropzone-popup";

export default {
  components: { vueDropzone: vue2Dropzone, DropzonePopup, vendorService},
    data() {
        return {
            checked: true,
            file1: null,
            tmpCategoryImage: "",
            url: null,
            config: config,
            category_id: this.$route.params.category_id,
            restaurant_id: "",
            typeform: {
                menu_name: "",
                menu_name_thai:"",
                status: "1",
                image: "",
                menu_description: "",
                category_id: this.category_id,
                restaurant_id:"",
            },
        };
    },
    validations: {
        typeform: {
            menu_name: {
                required,
            },
            menu_name_thai: {
                required
            },
            image: {
                required,
            },
        },
    },
    methods: {
        onFileChange(e) {
            const file = e.target.files[0];
            this.url = URL.createObjectURL(file);
            this.typeform.image = file;
        },
        addMenu() {
            this.$v.typeform.$touch();
            if (this.$v.typeform.$invalid) {
                setTimeout(()=>{
                    $(".is-invalid:first").focus();
                },500);
                return;
            } else {
                vendorService.addMenu({...this.typeform,category_id: this.category_id}).then((response) => {
                    if (response.data.code === 200) {
                        success_message(response.data.message);
                        this.$router.push({ name: "sub-category-list" });
                    } else {
                        error_message(response.data.message);
                    }
                });
            }
        },
    },
};
</script>

<template>
    <form @submit.prevent="addMenu">
        <!-- Category Info Start -->
        <div class="card">
            <div class="card-body">
                <h4 class="card-title">{{ trans.get('__JSON__.Sub Category Info') }}</h4>
                <p class="card-title-desc"></p>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group" v-if="$auth.setting">
                            <label class="required">{{ trans.trans('__JSON__.Sub Category Name Language',{ lang: $auth.langauges[0].name }) }}</label>
                            <input
                                id="menu_name"
                                v-model="$v.typeform.menu_name.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Sub Category Name Language',{lang: $auth.langauges[0].name})"
                                name="menu_name"
                                :class="{ 'is-invalid': $v.typeform.menu_name.$error }"
                            />
                            <div v-if="$v.typeform.menu_name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.menu_name.required">{{ trans.get('__JSON__.Please enter sub category name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6" v-if="$auth.langauges[1].name !== 'No Secondary Language'">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Sub Category Name Language',{lang: $auth.langauges[1].name }) }}</label>
                            <input
                                id="menu_name_thai"
                                name="menu_name_thai"
                                type="text"
                                v-model="$v.typeform.menu_name_thai.$model"
                                :placeholder="trans.trans('__JSON__.Sub Category Name Language',{lang: $auth.langauges[1].name })"
                                class="form-control"
                                :class="{ 'is-invalid': $v.typeform.menu_name_thai.$error }"
                            />
                             <div v-if="$v.typeform.menu_name_thai.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.menu_name_thai.required">{{ trans.get('__JSON__.Please enter sub category name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <div class="form-group" v-if="$auth.setting">
                            <label>{{ trans.trans('__JSON__.Sub Category Description Language',{lang: $auth.langauges[0].name }) }}</label>
                            <input
                                rows="5"
                                id="menu_description"
                                name="menu_description"
                                type="text"
                                v-model="typeform.menu_description"
                                :placeholder="trans.trans('__JSON__.Sub Category Description Language',{lang: $auth.langauges[0].name })"
                                class="form-control"
                            />
                        </div>
                    </div>

                    <div class="col-md-6 vendor-status">
                        <b-form-group id="input-group-2" :label="trans.get('__JSON__.Status')" label-for="Status" >
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="swtich-data">
                                        <label class="switch">
                                        <input
                                            type="checkbox"
                                            id="togBtn"
                                            class="switch-on"
                                            name="status"
                                            v-model="typeform.status"
                                            true-value="1"
                                            false-value="0"
                                        />
                                        <div class="slider round">
                                            <!--ADDED HTML -->
                                            <span class="on">{{ trans.get('__JSON__.Active') }}</span>
                                            <span class="off">{{ trans.get('__JSON__.Inactive') }}</span>
                                            <!--END-->
                                        </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </b-form-group>
                    </div>
                </div>
            </div>
        </div>
        <!-- Category Info End -->

        <!-- Category Image Start -->
        <div class="card">
            <div class="card-body">
                <h4 class="card-title required">{{ trans.get('__JSON__.Sub Category Image') }}</h4>
                <p class="card-title-desc"></p>

                <div class="row">
                    <div class="col-sm-3">
                        <dropzone-popup
                        v-model="$v.typeform.image.$model"
                        type="file"
                        id="image"
                        name="image"
                        acceptedFiles=".jpeg,.jpg,.png"
                        />
                        <div v-if="$v.typeform.image.$error" class="invalid-feedback cuisine-img">
                        <span
                            v-if="!$v.typeform.image.required"
                        >{{ trans.get('__JSON__.Please select sub category image') }}.</span>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-6">
                        <button class="btn btn-primary mr-1 mt-3">{{ trans.get('__JSON__.Add Sub Category') }}</button>
                        <!-- <b-button @click="$router.go(-1)" type="button" variant="secondary" class="mt-3">{{ trans.get('__JSON__.Cancel') }}</b-button> -->
                        <router-link
                            :to="{name:'sub-category-list'}"
                        >
                            <b-button 
                                type="button" 
                                variant="secondary" 
                                class="mt-3">
                                {{ trans.get('__JSON__.Cancel') }}
                            </b-button>
                        </router-link>                            
                    </div>
                </div>
            </div>
        </div>
        <!-- Category Image End -->
    </form>
</template>

<style>
</style>